import {useQuery} from '@tanstack/react-query';

import {QueryOptionsForOne} from '@shared/api';
import {getVoucherConfig} from '../api';
import {QUERY__VOUCHER_CONFIG} from '../queryKeys';
import {VoucherConfigDetails} from '../types';

export const useGetVoucherConfig = <SelectedData = VoucherConfigDetails>(
  id: string,
  options?: QueryOptionsForOne<VoucherConfigDetails, SelectedData>,
) =>
  useQuery({
    queryKey: [QUERY__VOUCHER_CONFIG, id],
    queryFn: () => getVoucherConfig(id),
    ...options,
  });
